import React, { FunctionComponent, useRef, SyntheticEvent, useState } from 'react';
import KnovioLogo from '../../assets/images/Knovio-logo.png';
import HeaderNavItems from './header-navs';
import MobileMenuIcon from '../shared/mobile-menu-icon/mobile-menu-icon';
import classnames from 'classnames';
import TransparentButton from '../shared/transparent-button/transparent-button';
import './header.scss';
import { getPodiumInfoStore } from '../../store/podium-info-store/podium-info-store-instance';
import { SMALL_MOBILE_BREAKPOINT } from '../../constans/responsive-break-points';
import { observer } from 'mobx-react';

interface IHeaderProps {
  urlPath: string;
  presentationName: string;
  interfaceBrandingLogoUrl: string;
  isPodiumPollsEnabled?: boolean | null;
  hasNavigation?: boolean;
  isPodiumAttendeesEnabled?: boolean | null;
  isPodiumEnabled?: boolean | null;
  isQandaEnabled?: boolean | null;
  isPodiumSlidesEnabled?: boolean | null;
  isPodiumPresenterQuestionsEnabled?: boolean;
  getPreviewInformation?: () => Promise<void>;
}

const Header: FunctionComponent<IHeaderProps> = (
  {
    urlPath,
    presentationName,
    interfaceBrandingLogoUrl,
    isPodiumPollsEnabled = false,
    hasNavigation,
    isPodiumAttendeesEnabled = false,
    isPodiumEnabled = false,
    isQandaEnabled = false,
    isPodiumSlidesEnabled = false,
    isPodiumPresenterQuestionsEnabled = false,
    getPreviewInformation
  }): JSX.Element => {
  const mobileMenuRef = useRef<HTMLElement>(null);
  const [isOpenMobileMenu, setIsOpenMobileMenu] = useState<boolean>(false);
  const navigationWrapperClasses = classnames('kv-presenter-header__nav', { 'opened': isOpenMobileMenu });
  const isVerySmallMobile = getPodiumInfoStore().isResolutionBreakPointActive(SMALL_MOBILE_BREAKPOINT);

  const toggleMobileMenu = (event: SyntheticEvent<HTMLAnchorElement | HTMLDivElement | HTMLUListElement>): void => {
    event.preventDefault();
    const { currentTarget: { dataset }} = event;
    if (dataset.action) {
      setIsOpenMobileMenu(false);
      return;
    }
    if (mobileMenuRef.current) {
      setIsOpenMobileMenu(!isOpenMobileMenu);
    }
  };

  return (
    <header className="kv-presenter-header">
      <div className="kv-presenter-header__info">
        <img
          className="kv-presenter-header__logo" src={interfaceBrandingLogoUrl || KnovioLogo}
          alt="Knovio logo"
        />
        <p className="kv-presenter-header__name" title={presentationName}>
          {presentationName}
        </p>
        {getPreviewInformation && !isVerySmallMobile
          ? <TransparentButton onClick={getPreviewInformation} customClasses='preview-button'>Preview</TransparentButton>
          : null
        }
      </div>
      {hasNavigation && (
        <nav
          className={navigationWrapperClasses}
          ref={mobileMenuRef}
        >
          <div className="mobile-menu-overlay" onClick={toggleMobileMenu}/>
          <MobileMenuIcon toggleMenu={toggleMobileMenu} isOpen={isOpenMobileMenu}/>
          <HeaderNavItems
            isPodiumEnabled={isPodiumEnabled}
            isQandaEnabled={isQandaEnabled}
            isPodiumPollsEnabled={isPodiumPollsEnabled}
            isPodiumPresenterQuestionsEnabled={isPodiumPresenterQuestionsEnabled}
            url={urlPath}
            toggleMobile={toggleMobileMenu}
            isPodiumAttendeesEnabled={isPodiumAttendeesEnabled}
            isPodiumSlidesEnabled={isPodiumSlidesEnabled}
            getPreviewInformation={getPreviewInformation}
            isMobile={isVerySmallMobile}
          />
        </nav>
      )}
    </header>
  );
};

export default observer(Header);
